
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 20c.444 0 1 .448 1 1s-.556 1-1 1H5c-.444 0-1-.448-1-1s.556-1 1-1zM11.978 2c2.576 0 4.665 2.071 4.665 4.626a4.604 4.604 0 01-1.766 3.625l.194 2.772h2.643c2.366 0 4.286 1.904 4.286 4.25v.133c0 .88-.71 1.594-1.585 1.594H3.585A1.59 1.59 0 012 17.406v-.133c0-2.346 1.92-4.25 4.286-4.25h2.598l.194-2.772a4.604 4.604 0 01-1.765-3.625C7.313 4.071 9.4 2 11.977 2zm0 2c-1.476 0-2.665 1.18-2.666 2.628 0 .797.367 1.552 1.001 2.05l.834.655-.398 5.69H6.286c-1.171 0-2.132.867-2.27 1.977h15.967l-.025-.157a2.278 2.278 0 00-2.244-1.82h-4.508l-.398-5.69.834-.655a2.604 2.604 0 001-2.052C14.643 5.18 13.454 4 11.979 4z"}})])
          )
        }
      }
    